import { ENV } from '@/constants';
import { exploreSchemaItemList } from '../exploreSchema';

export const schemaObject_AiBarbieDoll = {
	'@context': 'https://schema.org',
	'@graph': [
		{
			'@type': 'WebPage',
			'@id': 'https://liftapp.ai/ai-barbie-doll',
			name: 'AI Barbie Generator – Create Custom AI Dolls | Lift',
			description:
				"Transform yourself into a Barbie doll with Lift's AI-powered Barbie generator. Create stunning Barbie-style AI selfies in seconds — no design skills needed No watermark. Try it online now!",
			url: 'https://liftapp.ai/ai-barbie-doll',
			image: 'https://liftapp.ai/seo-image.webp',
			mainEntity: [
				{ '@id': 'https://liftapp.ai/ai-barbie-doll#product' },
				{ '@id': 'https://liftapp.ai/ai-barbie-doll#howto' },
				{ '@id': 'https://liftapp.ai/ai-barbie-doll#benefits' },
				{ '@id': 'https://liftapp.ai/ai-barbie-doll#faq' },
				{ '@id': 'https://liftapp.ai/ai-barbie-doll#why-lift' },
				{ '@id': 'https://liftapp.ai/ai-barbie-doll#explore-tools' },
				{ '@id': 'https://liftapp.ai/ai-barbie-doll#all-in-one' },
			],
		},
		// product
		{
			'@type': 'Product',
			'@id': 'https://liftapp.ai/ai-barbie-doll#product',
			name: 'AI Barbie Generator Online',
			description:
				"Transform yourself into a Barbie doll with Lift's AI-powered Barbie Generator. Create stunning Barbie-style AI selfies in seconds — no design skills needed. Try it — no watermark.",
			url: 'https://liftapp.ai/ai-barbie-doll',
			fileFormat: ['image/jpeg', 'image/png', 'image/webp'],
			memoryRequirements: 'Max file size: 20MB',
			brand: {
				'@type': 'Brand',
				name: 'Lift',
			},
			aggregateRating: {
				'@type': 'AggregateRating',
				ratingValue: '4.8',
				reviewCount: 130000,
				bestRating: '5',
				worstRating: '1',
			},
			interactionStatistic: [
				{
					'@type': 'InteractionCounter',
					interactionType: { '@type': 'InstallAction' },
					userInteractionCount: 13000000,
				},
			],
		},
		// howto
		{
			'@type': 'HowTo',
			'@id': 'https://liftapp.ai/ai-barbie-doll#howto',
			name: 'How it works',
			step: [
				{
					'@type': 'HowToStep',
					position: 1,
					name: 'Upload your photos',
					text: "Choose a photo from your device or take one using Lift's app",
				},
				{
					'@type': 'HowToStep',
					position: 2,
					name: 'Transform into a Barbie doll',
					text: 'Our AI instantly converts your photo into a Barbie-style doll with iconic features, vibrant colors, and that signature Barbie glow',
				},
				{
					'@type': 'HowToStep',
					position: 3,
					name: 'Customize adjustments',
					text: 'Fine-tune your image with easy-to-use editing tools',
				},
				{
					'@type': 'HowToStep',
					position: 4,
					name: 'Download and use',
					text: 'Download your image or publish it straight to your social feeds',
				},
			],
		},
		// benefit
		{
			'@type': 'ItemList',
			'@id': 'https://liftapp.ai/ai-barbie-doll#benefits',
			name: 'Who can benefit from AI Barbie Generator?',
			description:
				"Lift's AI Barbie Generator is useful for Barbie fans, social media enthusiasts, content creators, party planners, and anyone looking for creative fun.",
			itemListOrder: 'Unordered',
			itemListElement: [
				{
					'@type': 'ListItem',
					position: 1,
					name: 'Perfect for Barbie fans who want to join the viral AI Barbie trend',
				},
				{
					'@type': 'ListItem',
					position: 2,
					name: 'Social media enthusiasts can create shareable Barbie selfies that go viral',
				},
				{
					'@type': 'ListItem',
					position: 3,
					name: 'Content creators can generate eye-catching Barbie-themed visuals for TikTok, Instagram, and YouTube',
				},
				{
					'@type': 'ListItem',
					position: 4,
					name: 'Party planners can design custom Barbie invitations and decorations in minutes',
				},
				{
					'@type': 'ListItem',
					position: 5,
					name: 'Quick, creative, and premium-quality — ideal for personal fun',
				},
			],
			image: {
				'@type': 'ImageObject',
				contentUrl:
					'https://liftapp.ai/_next/static/media/benefits.3da6de53.webp',
				name: 'Benefits image',
				description: 'Users enjoying AI Barbie Generator',
			},
		},

		// faq
		{
			'@type': 'FAQPage',
			'@id': 'https://liftapp.ai/ai-barbie-doll#faq',
			mainEntity: [
				{
					'@type': 'Question',
					name: 'What is Lift AI Barbie Generator?',
					acceptedAnswer: {
						'@type': 'Answer',
						text: 'Lift AI Barbie Generator is an online tool that transforms your photos into AI-powered Barbie dolls — complete with the iconic Barbie look, vibrant styling, and doll-like features.',
					},
				},
				{
					'@type': 'Question',
					name: 'How does Lift AI Barbie Generator work?',
					acceptedAnswer: {
						'@type': 'Answer',
						text: 'Our AI analyzes your photo with deep learning, preserves your facial features, and reimagines you as a Barbie doll with signature styling — from the glossy hair and flawless complexion to the bright, colorful aesthetic. Everything is automatic — no manual editing needed.',
					},
				},
				{
					'@type': 'Question',
					name: 'Can I create AI Barbie dolls with any photo?',
					acceptedAnswer: {
						'@type': 'Answer',
						text: 'Yes. Lift works with any portrait photo — selfies, professional shots, or casual pics. The AI adapts to your unique features and creates custom doll transformations inspired by classic Barbie aesthetics.',
					},
				},
				{
					'@type': 'Question',
					name: 'Can I download the results without a watermark?',
					acceptedAnswer: {
						'@type': 'Answer',
						text: "Absolutely. All images generated or edited in Lift can be exported without watermark when you're on the Pro plan. Download them in high-res PNG or JPG — ready for social media, print, gifts, or personal projects.",
					},
				},
			],
		},

		// why lift
		{
			'@type': 'ItemList',
			'@id': 'https://liftapp.ai/ai-barbie-doll#why-lift',
			name: "Why Lift's AI Barbie Generator stands out",
			description:
				"Lift's AI Barbie Generator combines professional-grade AI, ease of use, and affordability — making it a trusted choice for millions of users worldwide.",
			itemListOrder: 'Unordered',
			itemListElement: [
				{
					'@type': 'ListItem',
					position: 1,
					name: 'High-quality results',
					description:
						'AI-powered technology delivers professional-grade visuals every time',
				},
				{
					'@type': 'ListItem',
					position: 2,
					name: 'Intelligent rendering',
					description:
						'AI tailors the effect to the scene and subject for optimal results',
				},
				{
					'@type': 'ListItem',
					position: 3,
					name: 'Cross-platform support',
					description: 'Available on iOS, Android, and Web for seamless access',
				},
				{
					'@type': 'ListItem',
					position: 4,
					name: 'Budget-friendly',
					description:
						'Save on costly designers with an affordable and intuitive tool',
				},
			],
			image: {
				'@type': 'ImageObject',
				contentUrl:
					'https://liftapp.ai/_next/static/media/whyUse.ae83a89c.webp',
				name: 'Why Lift image',
				description: 'AI Barbie Generator advantages',
			},
		},
		// explore
		{
			'@type': 'ItemList',
			'@id': 'https://liftapp.ai/ai-barbie-doll#explore-tools',
			name: 'Explore the AI tools',
			description:
				'A curated list of AI-powered tools for image generation, enhancement, background removal, and more – all available on Lift.',
			itemListOrder: 'Unordered',
			...exploreSchemaItemList,
		},

		{
			'@type': 'SoftwareApplication',
			'@id': 'https://liftapp.ai/ai-barbie-doll#all-in-one',
			name: 'Try Lift – AI Content Creation Tools',
			description:
				'Your all-in-one tools to create, edit, and elevate your content. Create stunning content with AI tools, templates, and editing features effortlessly.',
			operatingSystem: 'iOS, Android, Web',
			applicationCategory: 'MultimediaApplication',
			url: `${ENV.LIFT_WEB_APP_URL}/sign-in?auto_login=true`,
			applicationSubCategory: 'Content Creation',
			publisher: {
				'@type': 'Organization',
				name: 'Lift',
				url: 'https://liftapp.ai',
			},
			potentialAction: [
				{
					'@type': 'ViewAction',
					name: 'Open Web App',
					target: `${ENV.LIFT_WEB_APP_URL}/sign-in?auto_login=true`,
				},
			],
		},

		{
			'@type': 'BreadcrumbList',
			itemListElement: [
				{
					'@type': 'ListItem',
					position: 1,
					name: 'Home',
					item: 'https://liftapp.ai',
				},
				{
					'@type': 'ListItem',
					position: 2,
					name: 'AI Barbie Generator',
					item: 'https://liftapp.ai/ai-barbie-doll',
				},
			],
		},
	],
};
